export const FILTERS_SEARCH_LAYOUT_SEARCH_REQUEST_START_REQUESTED =
  'filters/layoutSearch/SEARCH_REQUEST_START_REQUESTED';
